import { user } from 'utils/auth/user';
import { runApplyingRemote } from './remoteApplyGuard';

/**
 * Apply a 3D Showroom announcement (`update:pr-string`, `update:consumption-data`).
 *
 * A customer's Showroom mirrors the dealer's car, so a customer applies it locally and syncs
 * nothing, emit-only included (AVS-4412). It runs as a remote apply, the switch `syncToServer`
 * already honours; a write already pending from a real customer edit still goes out.
 * A dealer keeps saving: the dealer's write is how an announced car reaches the record.
 */
export function runShowroomAnnouncement(apply: () => void): void {
  if (user.isDealer) {
    apply();
    return;
  }
  runApplyingRemote(apply);
}
